import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Represents Contact Us.
 * @author Amresh Yadav
 */import React, { Component } from 'react';
import styled from 'styled-components';
import styles from './ContactUsNva.style';
import { formLabels, formErrorMessages } from '../../../constants/labels/en';
import { sendEmail } from '../../../utils/formUtility';
import analyticsConstants from '../../../constants/analyticsConstants';
import Form from '../Form';
import Button from '../../atoms/Button';
import Heading from '../../atoms/Heading';
import ReCaptcha from '../../molecules/ReCaptcha';
import { formsCaptchaActions } from '../../../constants/globalConstants';
var ContactUsFormNva = /*#__PURE__*/function (_Component) {
  _inherits(ContactUsFormNva, _Component);
  var _super = _createSuper(ContactUsFormNva);
  function ContactUsFormNva(props) {
    var _this;
    _classCallCheck(this, ContactUsFormNva);
    _this = _super.call(this, props);
    _this.submitContactUsForm = _this.submitContactUsForm.bind(_assertThisInitialized(_this));
    _this.successCallback = _this.successCallback.bind(_assertThisInitialized(_this));
    _this.failureCallback = _this.failureCallback.bind(_assertThisInitialized(_this));
    _this.saveCaptchaToken = _this.saveCaptchaToken.bind(_assertThisInitialized(_this));
    _this.state = {
      isSuccessfulSubmission: false,
      errorEmailSending: false,
      captchaToken: ''
    };
    return _this;
  }
  _createClass(ContactUsFormNva, [{
    key: "successCallback",
    value: function successCallback() {
      this.setState({
        isSuccessfulSubmission: true
      });
    }
  }, {
    key: "failureCallback",
    value: function failureCallback() {
      this.setState({
        errorEmailSending: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var element = document.getElementById('submit-response');
      if (element) {
        element.scrollIntoView();
      }
    }
  }, {
    key: "submitContactUsForm",
    value: function submitContactUsForm(values) {
      if (values.ohhoneyname.length > 0) {
        //console.log('we caught a bot!')
        this.setState({
          errorEmailSending: true
        });
      } else {
        sendEmail(values, this.props.contactUsData.submitUrl, this.state.captchaToken, this.successCallback, this.failureCallback);
      }
    }
  }, {
    key: "saveCaptchaToken",
    value: function saveCaptchaToken(captchaToken) {
      this.setState(function () {
        return {
          captchaToken: captchaToken
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props, _this$props2;
      /* contact form label props */
      var labelProps = {
        className: "nva-contact-us-nva__form-label contact-form-label"
      };
      var userFormProps = {
        initialValues: {
          customer_email: '',
          ohhoneyname: '',
          name: '',
          phone: '',
          title: '',
          businessName: '',
          businessAddress: '',
          message: ''
        },
        action: this.props.contactUsData.submitUrl,
        method: 'POST',
        acceptCharset: 'UTF-8',
        validationSchema: ['customer_email', 'name', 'phone', 'title', 'businessName', 'businessAddress'],
        handleSubmit: this.submitContactUsForm
      };
      var nvaContactUs = {
        userFormNameInputProps: {
          name: 'name',
          type: 'text',
          id: 'name',
          label: formLabels.nvaContactUsForm.NAME,
          ariaLabel: 'Name',
          'aria-required': true,
          className: 'input-field-wrapper',
          labelProps: labelProps
        },
        honepotInputProps: {
          name: 'ohhoneyname',
          type: 'text',
          autocomplete: 'off',
          id: 'ohhoneyname',
          label: formLabels.nvaContactUsForm.NAME,
          ariaLabel: 'Oh Honey Name',
          className: 'input-field-wrapper-oh',
          labelProps: labelProps
        },
        userFormEmailProps: {
          type: 'email',
          name: 'customer_email',
          label: formLabels.nvaContactUsForm.EMAIL,
          id: 'customer_email',
          ariaLabel: 'Email',
          'aria-required': true,
          className: 'input-field-wrapper',
          labelProps: labelProps
        },
        userFormPhoneProps: {
          type: 'text',
          name: 'phone',
          label: formLabels.nvaContactUsForm.PHONE,
          id: 'phone',
          ariaLabel: 'Phone',
          'aria-required': true,
          className: 'input-field-wrapper',
          labelProps: labelProps
        },
        userFormtitleProps: {
          type: 'text',
          name: 'title',
          label: formLabels.nvaContactUsForm.TITLE,
          id: 'title',
          ariaLabel: 'Title',
          'aria-required': true,
          className: 'input-field-wrapper',
          labelProps: labelProps
        },
        userFormBusinessNameProps: {
          type: 'text',
          name: 'businessName',
          label: formLabels.nvaContactUsForm.BUSINESSNAME,
          id: 'businessName',
          ariaLabel: 'Business Name',
          'aria-required': true,
          className: 'input-field-wrapper',
          labelProps: labelProps
        },
        userFormbusinessAddProps: {
          type: 'text',
          name: 'businessAddress',
          label: formLabels.nvaContactUsForm.BUSINESSADDRESS,
          id: 'businessAddress',
          ariaLabel: 'Business Address',
          'aria-required': true,
          className: 'input-field-wrapper',
          labelProps: labelProps
        },
        userFormMessageProps: {
          name: 'message',
          label: formLabels.nvaContactUsForm.PERSONAL_MESSAGE,
          id: 'message',
          ariaLabel: 'Message',
          labelProps: labelProps
        }
      };
      var userFormNameInputProps = nvaContactUs.userFormNameInputProps;
      var honepotInputProps = nvaContactUs.honepotInputProps;
      var userFormPhoneProps = nvaContactUs.userFormPhoneProps;
      var userFormBusinessNameProps = nvaContactUs.userFormBusinessNameProps;
      var userFormtitleProps = nvaContactUs.userFormtitleProps;
      var userFormEmailProps = nvaContactUs.userFormEmailProps;
      var userFormbusinessAddProps = nvaContactUs.userFormbusinessAddProps;
      var userFormMessageProps = nvaContactUs.userFormMessageProps;
      if (this.state.isSuccessfulSubmission || (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.showSuccessMessage) {
        return __jsx("div", {
          className: "nva-contact-us-nva__form-submit-message ".concat(this.props.className),
          id: "submit-response"
        }, this.props.showHeading && this.props.showHeading !== false && __jsx(Heading, {
          HeadingType: "h2",
          className: "nva-contact-us-nva__form-heading form-heading"
        }, formLabels.nvaContactUsForm.FORM_HEADING), __jsx(Heading, {
          HeadingType: "h3",
          className: "nva-contact-us-nva__form-success-message success-message"
        }, this.props.contactUsData.successfulSubmissionMessage));
      }
      return __jsx("div", {
        className: "nva-contact-us-nva ".concat(this.props.className)
      }, this.props.showHeading && this.props.showHeading !== false && __jsx(Heading, {
        HeadingType: "h2",
        className: "nva-contact-us-nva__form-heading form-heading"
      }, formLabels.nvaContactUsForm.FORM_HEADING), this.state.errorEmailSending || ((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.showErrorMessage) && __jsx(Heading, {
        HeadingType: "h4",
        className: "nva-contact-us-nva__form-error-message error-message",
        id: "submit-response"
      }, formErrorMessages.nvaContactUsForm.EMAIL_SEND_ERROR), __jsx(Form, _extends({}, userFormProps, {
        className: "nva-contact-us-nva__form"
      }), __jsx(React.Fragment, null, __jsx("div", {
        className: "align-left"
      }, __jsx(Form.Input, _extends({}, honepotInputProps, {
        className: "nva-contact-us-nva__form-honepot-input"
      })), __jsx(Form.Input, _extends({}, userFormNameInputProps, {
        className: "nva-contact-us-nva__form-user-name-input"
      })), __jsx(Form.Input, _extends({}, userFormPhoneProps, {
        className: "nva-contact-us-nva__form-user-phone-input"
      })), __jsx(Form.Input, _extends({}, userFormBusinessNameProps, {
        className: "nva-contact-us-nva__form-user-business-name-input"
      }))), __jsx("div", {
        className: "align-right"
      }, __jsx(Form.Input, _extends({}, userFormtitleProps, {
        className: "nva-contact-us-nva__form-user-title-input"
      })), __jsx(Form.Input, _extends({}, userFormEmailProps, {
        className: "nva-contact-us-nva__form-user-email-input"
      })), __jsx(Form.Input, _extends({}, userFormbusinessAddProps, {
        className: "nva-contact-us-nva__form-user-business-address-input"
      }))), __jsx("div", {
        className: "messageBox row"
      }, __jsx(Form.TextArea, _extends({}, userFormMessageProps, {
        className: "nva-contact-us-nva__form-message-text-area"
      })), __jsx(Button, {
        className: "nva-contact-us-nva__form-submit-button",
        styleType: "primary",
        type: "submit",
        "data-analytics-type": analyticsConstants.nvaContactUs.analyticsType.CONTACT_FORM_TYPE,
        "data-analytics-value": analyticsConstants.nvaContactUs.analyticsValue.CONTACT_FORM_VALUE,
        "data-analytics-variation": ""
      }, formLabels.nvaContactUsForm.SUBMIT))), __jsx(ReCaptcha, {
        className: "nva-contact-us-nva__captcha",
        action: formsCaptchaActions.contactFormNVA,
        siteKey: this.props.contactUsData.reCaptchaKey,
        saveToken: this.saveCaptchaToken
      })));
    }
  }]);
  return ContactUsFormNva;
}(Component);
ContactUsFormNva.defaultProps = {
  className: '',
  showHeading: true,
  contactUsData: {}
};
export default styled(ContactUsFormNva).withConfig({
  componentId: "sc-10chv6r-0"
})(["", ";"], styles);
export { ContactUsFormNva as ContactUsFormNvaVanilla };